module.exports = __webpack_public_path__ + "static/img/commodityEndList.f1bb8c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/commodityEndList.png
// module id = PHj1
// module chunks = 1